
// Utility class to handle assigning resources to services, with checks for future bookings affected

// The public method is serviceAssignedResources which takes in the service with updated assigned resources, the original assigned resources array,
// the restComponent to use for fetches and alerts, and onCancel and onSuccess callbacks
// If any assigned resources were removed, and there are future bookings affected, the user is warned before proceeding
// If the user cancels, the onCancel callback is called, passing in the service (with its assignedResourceIds reverted to originalAssignedResources)
// If the user confirms, the onSuccess callback is called, passing in the service

export class AssignResourceHandler {

    // When the user selects the resources to assign to the service, check if any resources were removed, to warn the user
    static serviceAssignedResources = (service, originalAssignedResources, restComponent, onCancel, onSuccess) => {

        // Get an array of removed resources
        const removedResources = originalAssignedResources.filter((r) => !service.assignableResourceIds.includes(r));

        if (removedResources.length > 0) {
            // Get a comma separated string of resource IDs, from the removedResources array
            const resourceIDs = removedResources.join(",");

            restComponent.secureJSONFetch("/bk/resources/futureSlotCounts?resourceIDs=" + resourceIDs, {}, 
                                (response) => AssignResourceHandler._serviceAssignedResourcesCallback(response, service, originalAssignedResources, restComponent, onCancel, onSuccess),
                                 (error) => AssignResourceHandler._fetchErrorCallback(error, restComponent));
            return;
        }
        
        // unchanged, just update the service
        AssignResourceHandler._serviceAssignedResourcesCallback(null, service, originalAssignedResources, restComponent, onCancel, onSuccess);
    }   

    static _serviceAssignedResourcesCallback = (response, service, originalAssignedResources, restComponent, onCancel, onSuccess) => {

        if (response) {
            let notice = "";
            if (response.futureBookingsAffected > 0) {
                notice += "You are removing " + response.resourceIDs.length + " assigned Resources from the Service: \"" + service.name + "\". There are " + 
                        response.futureBookingsAffected + " future Bookings assigned these Resources that will no longer have the Resources assigned. Patrons are not notified.";

                restComponent.showConfirmAlert("Update Service Assigned Resources", 
                    notice, 'black',
                    "Cancel", 
                    () => AssignResourceHandler._confirmServiceAssignedResources(service, onSuccess),
                    "Proceed",
                    'green',
                    null,
                    () => AssignResourceHandler._cancelServiceAssignedResources(service, originalAssignedResources, onCancel)
                );

                return;
            }
        }
        AssignResourceHandler._confirmServiceAssignedResources(service, onSuccess);
    }

    static _cancelServiceAssignedResources = (service, originalAssignedResources, onCancel) => {
        service.assignableResourceIds = originalAssignedResources;  // revert the changes
        if (onCancel)
            onCancel(service);
    }

    static _confirmServiceAssignedResources = (service, onSuccess) => {
        if (onSuccess)
            onSuccess(service);
    }

    static _fetchErrorCallback = (error, restComponent) => {
        restComponent.showConfirmAlert("Error", error, 'red');
        restComponent.decrementBusy();
    }
}